// extracted by mini-css-extract-plugin
export var faqItem = "FaqItem-module--faqItem--1ESF3";
export var faqItemAnswer = "FaqItem-module--faqItemAnswer--8c4Y3";
export var faqMarkdown = "FaqItem-module--faqMarkdown--8TzQI";